import React from 'react';
import { connect } from 'dva';
import { Button, Drawer, Row, Col } from 'antd';
import Dimio, {DimioComponent, DimioNotice} from 'dimio';
import ListPage from './ListPage';
import ProductItem from './ProductItem';

//import EntryMap from './EntryMap';

import config from '../config/config';
import "../style/travel.scss"
const {travel} = config;

/**
 * type: loader - loading item by NOI
 */
class TravelPage extends DimioComponent {
  constructor(props) {
    super(props);
/*
    this.state = {
      showPanel: false
    };
*/
//    this.onSelect = this.onSelect.bind(this);
//    this.onOpenPanel  = this.onOpenPanel.bind(this);
//    this.onClosePanel = this.onClosePanel.bind(this);
  }

  componentWillMount() {
    const {dispatch, core:{defaultValues} } = this.props;
    this.showLoading();
    const self = this;

    Dimio.load(travel.api.tourByCity, {
      city: defaultValues.city,
      noi: 0
    }).then(res => {
      dispatch({
        type: 'travel/setProducts',
        items: res.data,
        meta:  res.meta
      });

      self.hideLoading();
    }).catch(err => {
      console.error(err);
      self.hideLoading();
    });
  }
/*
  onOpenPanel(){
    this.setState({showPanel: true});
  }

  onClosePanel(){
    this.setState({showPanel: false});
  }
*/
/*
  onSelect(){
    dispatch({
      type: 'travel/selectProduct',
      item: item,
    });
  }
*/
  render() {
    const { core, travel:{items} } = this.props;

    return (
      <section>
        <DimioNotice {...core} />

        {items &&
        <ListPage
          onClose={this.onClosePanel}
          asPage={true}
          items={items}
//          model={core.model}
        />
        }
      </section>
    );
  }
}

export default connect(({ core, travel }) => ({
  core, travel
}))(TravelPage);



// WEBPACK FOOTER //
// ./src/pages/travel/components/TravelPage.js